import { useBroadcastChannel } from './useBroadcastChannel';
import useIsTabActive from './useIsTabActive';
import {
  DOUBLE_GATE_BROADCAST_CHANNEL,
  DOUBLE_GATE_MESSAGE_TYPE,
  ENTITY_TYPE,
} from '../libs/constants';
import { DoubleGateMessage, Enum } from '../libs/types';
import { getCookie } from '../utils/cookies';

/**
 * 1. Listens to child request for parent details
 * 2. Responds with parent leadUuid, entityId and entityType
 */
export const useLeadFormPrefillParentListener = (
  entityId: string,
  entityType: Enum<typeof ENTITY_TYPE>,
) => {
  const tabHasFocus = useIsTabActive();
  useBroadcastChannel(
    DOUBLE_GATE_BROADCAST_CHANNEL,
    (message: DoubleGateMessage, channel: BroadcastChannel) => {
      /** Must verify type and focus. Dont remove ? */
      if (tabHasFocus && message?.type === DOUBLE_GATE_MESSAGE_TYPE.REQUEST_PARENT_LEAD_DETAILS) {
        const leadUuid = getCookie(entityId);
        if (!leadUuid) {
          return;
        }
        channel.postMessage({
          leadUuid,
          entityId,
          entityType,
          type: DOUBLE_GATE_MESSAGE_TYPE.RESPONSE_PARENT_LEAD_DETAILS,
          requestId: message.requestId,
        });
      }
    },
  );
};
